import { PriorityRankingCategoryBase } from './base/priority-ranking-category-base';

export class PriorityRankingCategory extends PriorityRankingCategoryBase { }